import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { LOADER_TIMEOUT_TIME, SWAL_SETTINGS } from "../../../../../utils/Constants";
import { handleServerValidations } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { configureTaxSettings, updateTaxSettings } from "../../../services/tax.services";
import * as Yup from 'yup';
import { getRestaurantSettings } from "../../../services/profile.services";
import { addRestData } from "../../../../../redux/slices/restSettings";
import { useDispatch } from "react-redux";
import Skeleton from "react-loading-skeleton";

function Tax() {
  const { t } = useTranslation();
  const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
  const [refreshRestroSettings, setRefreshRestroSettings] = useState(false);
  const [taxSettings, setTaxSettings] = useState({});
  const dispatch = useDispatch();
  const [Loader, setLoader] = useState(false);


  useEffect(() => {
    setLoader(true);
    getRestaurantSettings()
      .then((response) => {
        dispatch(addRestData(response.data))
        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
        setTaxSettings(response && response?.data ? response?.data : {});
      })
      .catch((error) => {
        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
        console.log("Error===>", error);
      });
  }, [refreshRestroSettings]);

  const formTaxUpdate = useFormik({
    initialValues: {
      certain_baby_food_item_tax: taxSettings.certain_baby_food_item_tax || 0,
      general_tax: taxSettings.general_tax || 0,
    },
    validationSchema: Yup.object().shape({
      certain_baby_food_item_tax: Yup.number()
        .required(t("Certain baby food item vat is required"))
        .min(1, t("Certain baby food item vat should be at least 1"))
        .max(100, t("Certain baby food item vat cannot be more than 100%"))
        .integer(t("Certain baby food item vat must be a whole number")),

      general_tax: Yup.number()
        .required(t("General vat is required"))
        .min(1, t("General vat should be at least 1"))
        .max(100, t("General vat cannot be more than 100%"))
        .integer(t("General vat must be a whole number")),
    }),
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      setAddSubmissionLoader(true);
      const formData = new FormData();
      formData.append("certain_baby_food_item_tax", values.certain_baby_food_item_tax);
      formData.append("general_tax", values.general_tax);
      updateTaxSettings(formData)
        .then((response) => {
          setAddSubmissionLoader(false);
          if (response.success) {
            setRefreshRestroSettings(!refreshRestroSettings)
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            resetForm();
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
        })
        .catch((error) => {
          setAddSubmissionLoader(false);
          console.error("Error updating receipt", error);
        });
    },
  });

  return (
    <main id="main-content">
      <form onSubmit={formTaxUpdate.handleSubmit}>
        <div className="inner-container">
          <div className="page-header d-flex align-items-center">
            <h4 className="heading-title-text">Vat Settings</h4>
          </div>
          {
            Loader ? (
              <div className="service-charges-box">
                <div className="card">
                  <div className="card-body">
                    <Skeleton className="m-2" height={50} count={2} />
                  </div>
                </div>
              </div>
            ) : (
              <div className="card">
                <div className="card-body">
                  <div className="tax-input-list row ">
                    <div className="col-md-8 flex-column gap-4 d-flex">
                      <div className="row tax-input-list-row align-items-center">
                        <div className="col-md-4">
                          <h4>Certain baby food items<span style={{ color: "red" }}>*</span></h4>
                        </div>
                        <div className="col-md-8">
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Vat"
                            name="certain_baby_food_item_tax"
                            value={formTaxUpdate.values.certain_baby_food_item_tax}
                            onChange={formTaxUpdate.handleChange}
                            onBlur={formTaxUpdate.handleBlur}
                            onInvalid={(e) => e.preventDefault()}
                            onKeyDown={(e) => {
                              if (e.key === "e" || e.key === "E" || e.key === "+" || e.key === "-") {
                                e.preventDefault();
                              }
                            }}
                          />
                          {formTaxUpdate.touched.certain_baby_food_item_tax && formTaxUpdate.errors.certain_baby_food_item_tax ? (
                            <div className="text-danger">{t(formTaxUpdate.errors.certain_baby_food_item_tax)}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className="row tax-input-list-row align-items-center">
                        <div className="col-md-4">
                          <h4>General Vat<span style={{ color: "red" }}>*</span></h4>
                        </div>
                        <div className="col-md-8">
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Vat"
                            name="general_tax"
                            value={formTaxUpdate.values.general_tax}
                            onChange={formTaxUpdate.handleChange}
                            onBlur={formTaxUpdate.handleBlur}
                            onInvalid={(e) => e.preventDefault()}
                            onKeyDown={(e) => {
                              if (e.key === "e" || e.key === "E" || e.key === "+" || e.key === "-") {
                                e.preventDefault();
                              }
                            }}
                          />
                          {formTaxUpdate.touched.general_tax && formTaxUpdate.errors.general_tax ? (
                            <div className="text-danger">{t(formTaxUpdate.errors.general_tax)}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className="button-form mt-4">
                        <button type="submit" className={"btn btn-primary w-25" + (addSubmissionLoader ? " btn-loader" : "")}>
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
               )
              }
        </div>
      </form>
    </main>
  );
}

export default Tax;
